import ITagDetail from '@Shared.Angular/@types/core/contracts/queryModel/tagGroup/tagDetail';
import React from 'react';

type Props = {
  dataItem: ITagDetail;
  editTagGroup: (dataItem: ITagDetail) => void;
  deleteTagGroup: (dataItem: ITagDetail) => void;
  hasUpdatePermission: boolean;
};

const SetupTagGroupsActions: React.FC<Props> = ({
  dataItem,
  editTagGroup,
  deleteTagGroup,
  hasUpdatePermission
}) => {
  return (
    <td>
      <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <span
          onClick={() => editTagGroup(dataItem)}
          title="Edit Tag Group"
          className={`list-actions__action ${
            hasUpdatePermission ? '' : 'setup-tag-groups-actions-disabled'
          }`}
        >
          <i
            className="fa-light fa-pencil"
            id={`edit-tag-group-button-${dataItem.id}`}
          ></i>
        </span>

        <span
          onClick={() => deleteTagGroup(dataItem)}
          title="Delete Tag Group"
          className={`list-actions__action ${
            hasUpdatePermission ? '' : 'setup-tag-groups-actions-disabled'
          }`}
        >
          <i
            className="fa-light fa-trash-can"
            id={`delete-tag-group-button-${dataItem.id}`}
          ></i>
        </span>
      </div>
    </td>
  );
};

export default SetupTagGroupsActions;
